/**
 * API Module
 *
 * Service handlers for booking engine API calls
 */

import { alpitour_service_handler } from "@alpitour/services";
import { get_config } from "@utilities";
import { endpoints_keys } from "@alpitour/resources";

/**
 * Get keyds (destinations) based on search query
 */
export function get_keyds(q) {
  // condizioni uscita chiamata autocomplete
  if (!q) return [];
  if (q === "") return [];
  if (q.length < 3) return [];

  return alpitour_service_handler(
    endpoints_keys.keyds,
    {
      q: q,
      brands: get_config()["guiSettings"]["filterBrands"]
        ? get_config()["guiSettings"]["filterBrands"]
        : [],
    },
    {
      modal: false, // blocca la modal in caso di errore
    },
  ).then(
    (response) => {
      let suggestions = response.data.data.keyds;
      if (suggestions.length == 0) {
        suggestions = [
          {
            type: "noresults",
            keyd: "",
            label: "nessun risultato",
          },
        ];
      }
      return suggestions;
    },
    (error) => {
      error;
      return [
        {
          type: "noresults",
          keyd: "",
          label: "si è verificato un problema con la ricerca",
        },
      ];
    },
  );
}

/**
 * Get available airports for a destination
 */
export function get_airports_api(keyd, occupancy) {
  return alpitour_service_handler(endpoints_keys.airports, {
    keyd: keyd,
    occupancy: occupancy,
    brands: get_config()["guiSettings"]["filterBrands"]
      ? get_config()["guiSettings"]["filterBrands"]
      : [],
  });
}

/**
 * Get availabilities (dates) for selected airports
 */
export function get_availabilities_api(keyd, departure_airports, occupancy) {
  return alpitour_service_handler(endpoints_keys.availabilities, {
    keyd: keyd,
    departure_airports: Object.values(
      departure_airports.map((a) => {
        if (a.selected) {
          return [a.iata_code];
        }
        return [];
      }),
    ).flat(),
    mu: get_config()["mu"] ? get_config()["mu"] : "",
    occupancy: occupancy,
    brands: get_config()["guiSettings"]["filterBrands"]
      ? get_config()["guiSettings"]["filterBrands"]
      : [],
  });
}
